import React, { useState, useEffect, useRef } from 'react';
import '../scss/Emsmain.scss';
import Chart from 'react-apexcharts';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/header'
import BaseURL from '../assets/contants/BaseURL';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import { Pie } from 'react-chartjs-2';
import ExcelJS from 'exceljs';

const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

const EmsSubGroup = () => {
    const location = useLocation();
    const { group_name } = location.state || {};
    const [selectedDate, setSelectedDate] = useState(new Date());
    const navigate = useNavigate();
    const [widgetData, setWidgetData] = useState({
        today: [0, 0, 0],
        yesterday: [0, 0, 0],
        currentMonth: [0, 0, 0],
        lastMonth: [0, 0, 0],
    });
    const [loading, setLoading] = useState(true);
    // const [tableloading, settableLoading] = useState(true);
    const [loadingFlags, setLoadingFlags] = useState([]);
    const [submachines, setSubmachines] = useState([]);
    const [kWhValues, setKWhValues] = useState([]);
    const [totalKWh, setTotalKWh] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [chartDatas, setChartDatas] = useState({
        kWh: [],
        cost: [],
        co2: []
    });
    const [categorie, setCategorie] = useState([]);
    const [selectedNewYear, setSelectedNewYear] = useState(new Date().getFullYear());
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    // const [currentDay, setCurrentDay] = useState(1);
    // const [maxDaysInMonth, setMaxDaysInMonth] = useState(31);
    // const [isFetchingComplete, setIsFetchingComplete] = useState(false);
    const [monthlyData, setMonthlyData] = useState({
        categories: monthNames,
        kWh: Array(12).fill(null),
        cost: Array(12).fill(null),
        co2: Array(12).fill(null),
    });
    // const [isFetchingMonths, setIsFetchingMonths] = useState(false);
    // const [currentFetchingMonth, setCurrentFetchingMonth] = useState(0);
    // const [abortController, setAbortController] = useState(new AbortController());

    const [dailyData, setDailyData] = useState({
        categories: [],
        kw: [],
        cost: [],
        co2: []
    });
    const dataFetched = useRef(false);
    const [activeTab, setActiveTab] = useState("Daily");
    const [dailyDate, setDailyDate] = useState("");
    const [dailyloading, setDailyLoading] = useState(false);
    const [currentdailyreportPage, setCurrentdailyreportPage] = useState(1);
    const [dailyreportData, setDailyreportData] = useState([]);
    const [monthsData, setMonthsData] = useState([]);
    const [monthlyfromDate, setmonthlyFromDate] = useState(null);
    const [currentmonthlyreportPage, setCurrentmonthlyreportPage] = useState(1);
    const [monthlyloading, setMonthlyLoading] = useState(false);
    const tabs = ["Daily", "Monthly"];
    // const [containerColor, setContainerColor] = React.useState('#faffee');
    // const [daycontainerColor, setdayContainerColor] = React.useState('#fff3f3');
    // const [monthcontainerColor, setmonthContainerColor] = React.useState('#dbf4fe');
    // const [hourlychartColors, sethourlyChartColors] = useState({
    //                     kWh: '#4CAF50',
    //                     cost: '#2196F3',
    //                     co2: '#FFC107',
    //                 });

    //                 const handleColorChange = (seriesName, color) => {
    //                     sethourlyChartColors((prevColors) => ({
    //                         ...prevColors,
    //                         [seriesName]: color,
    //                     }));
    //                 };

    //                 const [dayschartColors, setdaysChartColors] = useState({
    //                     kWh: '#4B0082',
    //                     cost: '#FF8C00',
    //                     co2: '#00CED1',
    //                 });

    //                 const handledaysColorChange = (seriesName, color) => {
    //                     setdaysChartColors((prevColors) => ({
    //                         ...prevColors,
    //                         [seriesName]: color,
    //                     }));
    //                 };
    //                 const [monthlychartColors, setmonthlyChartColors] = useState({
    //                     kWh: '#FF4500',
    //                     cost: '#32CD32',
    //                     co2: '#1E90FF',
    //                 });

    //                 const handlemonthlyColorChange = (seriesName, color) => {
    //                     setmonthlyChartColors((prevColors) => ({
    //                         ...prevColors,
    //                         [seriesName]: color,
    //                     }));
    //                 };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.post(`${BaseURL}data/dailydata-consumption/`, {
                    group_name: group_name,
                    month: selectedMonth.toString(),
                    year: selectedYear.toString()
                });

                const { Daily_data } = response.data;
                const categories = [];
                const kw = [];
                const cost = [];
                const co2 = [];

                Object.entries(Daily_data).forEach(([date, values]) => {
                    categories.push(date);
                    kw.push(values[0]);
                    cost.push(values[1]);
                    co2.push(values[2]);
                });

                setDailyData({
                    categories,
                    kw,
                    cost,
                    co2
                });

            } catch (error) {
                console.error("Error fetching daily consumption data:", error);
                // setIsFetchingComplete(true);
            }
        };

        if (group_name) {
            fetchData();
        }

        const intervalId = setInterval(() => {
            if (group_name) {
                fetchData();
            }
        }, 180000);

        return () => clearInterval(intervalId);
    }, [selectedMonth, selectedYear, group_name]);


    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const response = await axios.get(`${BaseURL}meters/emsgroups/`);
                const groupData = response.data.find(group => group.group_name === group_name);
                if (groupData) {
                    const meterMap = {};
                    groupData.meter.forEach(meter => {
                        meterMap[meter.id] = meter;
                    });
                    const initialSubmachines = groupData.meter_order
                        .map(id => {
                            const meter = meterMap[id];
                            if (!meter) return null;
                            
                            return {
                                meter_name: meter.meter_name,
                                meter_id: meter.meter_id,
                                group_name: groupData.group_name,
                                total_kWh: 0,
                                total_cost: 0,
                            };
                        })
                        .filter(meter => meter !== null);

                    setSubmachines(initialSubmachines);
                    dataFetched.current = false;
                }
            } catch (error) {
                console.error('Error fetching initial data:', error);
            }
        };

        fetchInitialData();
    }, [group_name]);

    useEffect(() => {
        if (submachines.length === 0 || dataFetched.current) return;

        const fetchMeterData = async () => {
            try {
                setLoadingFlags(new Array(submachines.length).fill(true));
                const today = new Date().toISOString().split('T')[0];
                const response = await axios.post(`${BaseURL}data/meter-table/`, {
                    group_name: group_name,
                    date: today
                });

                const fetchedData = response.data;
                let updatedKWhValues = new Array(submachines.length).fill(0);
                let updatedTotalKWh = 0;

                for (let i = 0; i < submachines.length; i++) {
                    const meter = submachines[i];
                    const meterIndex = fetchedData.meter_id.indexOf(meter.meter_id);
                    const total_kWh = meterIndex !== -1 ? fetchedData.todays_kwh[meterIndex] : 0;
                    const total_cost = meterIndex !== -1 ? fetchedData.cost[meterIndex] : 0;

                    setSubmachines(prevSubmachines =>
                        prevSubmachines.map(m =>
                            m.meter_id === meter.meter_id ? { ...m, total_kWh, total_cost } : m
                        )
                    );

                    updatedKWhValues[i] = total_kWh;
                    updatedTotalKWh += total_kWh;

                    setKWhValues([...updatedKWhValues]);
                    setTotalKWh(updatedTotalKWh);

                    setLoadingFlags(prevFlags => {
                        const newFlags = [...prevFlags];
                        newFlags[i] = false;
                        return newFlags;
                    });
                    await new Promise(resolve => setTimeout(resolve, 500));
                }

                dataFetched.current = true;
            } catch (error) {
                console.error('Error fetching meter data:', error);
                // settableLoading(false);
            }
        };

        fetchMeterData();
    }, [group_name, submachines.length]);

    useEffect(() => {
        const today = new Date().toISOString().split('T')[0];
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await axios.post(`${BaseURL}data/meter-summary/`, {
                    date: today,
                    group_name: group_name,
                });
                setWidgetData({
                    today: response.data.today,
                    yesterday: response.data.yesterday,
                    currentMonth: response.data.current_month,
                    lastMonth: response.data.last_month,
                });
            } catch (error) {
                console.error('Error fetching meter summary data:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [group_name]);

    useEffect(() => {
        const fetchData = async () => {
            const formattedDate = selectedDate.toISOString().split('T')[0];
            try {
                const response = await axios.post(`${BaseURL}data/hourly-meter-consumption/`, {
                    group_name: group_name,
                    date: formattedDate,
                });

                const hourlyData = response.data.hourly_data || {};
                const categories = Object.keys(hourlyData);

                const kWhData = [];
                const costData = [];
                const co2Data = [];
                categories.forEach((time) => {
                    const [kWh, cost, co2] = hourlyData[time];
                    kWhData.push(kWh || 0);
                    costData.push(cost || 0);
                    co2Data.push(co2 || 0);
                });

                setCategorie(categories);
                setChartDatas({
                    kWh: kWhData,
                    cost: costData,
                    co2: co2Data,
                });
            } catch (error) {
                console.error("Error fetching hourly data:", error);
            }
        };

        fetchData();
    }, [selectedDate, group_name]);



    const fetchYearData = async () => {
        try {
            const response = await axios.post(`${BaseURL}data/monthlydata-consumption/`, {
                group_name: group_name,
                year: selectedNewYear.toString()
            });

            const data = response.data;
            setMonthlyData(prev => ({
                ...prev,
                kWh: Array(12).fill(0),
                cost: Array(12).fill(0),
                co2: Array(12).fill(0)
            }));

            Object.entries(data.monthly_data).forEach(([monthName, values]) => {
                const monthIdx = monthNames.findIndex(m =>
                    monthName.toLowerCase().startsWith(m.toLowerCase())
                );

                if (monthIdx !== -1) {
                    setMonthlyData(prev => ({
                        ...prev,
                        kWh: [...prev.kWh.slice(0, monthIdx), values[0], ...prev.kWh.slice(monthIdx + 1)],
                        cost: [...prev.cost.slice(0, monthIdx), values[1], ...prev.cost.slice(monthIdx + 1)],
                        co2: [...prev.co2.slice(0, monthIdx), values[2], ...prev.co2.slice(monthIdx + 1)],
                    }));
                } else {
                    console.error(`Month match not found for "${monthName}"`);
                }
            });

            // setIsFetchingMonths(false);
        } catch (error) {
            console.error("Error fetching yearly data:", error);
            // setIsFetchingMonths(false);
        }
    };

    useEffect(() => {
        if (group_name) {
            fetchYearData();
        }
    }, [selectedNewYear, group_name]);

    const handleNewYearChange = (e) => {
        const year = parseInt(e.target.value);
        setSelectedNewYear(year);
        setMonthlyData({
            categories: monthNames,
            kWh: Array(12).fill(null),
            cost: Array(12).fill(null),
            co2: Array(12).fill(null),
        });
        // setCurrentFetchingMonth(0);
    };

    const handleMonthChange = (e) => {
        const month = parseInt(e.target.value);
        setSelectedMonth(month);
        // setCurrentDay(1);
        // setIsFetchingComplete(false);
        // const daysInMonth = new Date(selectedYear, month, 0).getDate();
        // setMaxDaysInMonth(daysInMonth);
        setDailyData({
            categories: [],
            kw: [],
            cost: [],
            co2: []
        });
    };

    const handleYearChange = (e) => {
        const year = parseInt(e.target.value);
        setSelectedYear(year);
        // setCurrentDay(1);
        // setIsFetchingComplete(false);
        const daysInMonth = new Date(year, selectedMonth, 0).getDate();
        // setMaxDaysInMonth(daysInMonth);
        setDailyData({
            categories: [],
            kw: [],
            cost: [],
            co2: []
        });
    };

    const handleMeterClick = (meterId, groupName) => {
        navigate("/EMS/emssub", { state: { meterId, groupName } });
        window.scrollTo(0, 0);
        console.log(meterId, groupName)
    };

    const kWhPercentagesForPie = kWhValues.length > 0 && totalKWh > 0
        ? kWhValues.map((kWh) => {
            const percentage = (kWh / totalKWh) * 100;
            return percentage > 0 ? percentage : 0.001;
        })
        : new Array(submachines.length).fill(0);

    const getColorForMachine = (index) => {
        const colors = ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'];
        return colors[index % colors.length];
    };

    const pieChartData = {
        labels: submachines.map((machine) => machine.meter_name),
        datasets: [
            {
                data: kWhPercentagesForPie,
                backgroundColor: submachines.map((_, index) => getColorForMachine(index)),
            },
        ],
    };

    const indexOfLastMachine = currentPage * itemsPerPage;
    const indexOfFirstMachine = indexOfLastMachine - itemsPerPage;
    const currentMachines = submachines.slice(indexOfFirstMachine, indexOfLastMachine);

    const totalPages = Math.ceil(submachines.length / itemsPerPage);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);


    const handleTabChange = (tab) => {
        setActiveTab(tab);
        if (tab !== "Daily") {
            setDailyreportData([]);
            setDailyDate(0);
            setCurrentdailyreportPage(1);
        }
        if (tab !== "Monthly") {
            setMonthsData([]);
            setmonthlyFromDate(0);
            setCurrentmonthlyreportPage(1);
        }
    };


    const handleGetDailyReport = async () => {
        try {
            setDailyLoading(true);
            setCurrentdailyreportPage(1);

            const response = await axios.post(`${BaseURL}data/group-daily-report/`, {
                group_name: group_name,
                date: dailyDate
            });

            const data = response.data;

            setDailyreportData(data.meters.map(meter => ({
                meter_id: meter.meter_id,
                meter_name: meter.meter_name,
                totalKwh: meter.total_kwh,
                totalCost: meter.total_cost,
                totalCo2: meter.total_co2,
                startKwh: meter.start_kwh,
                endKwh: meter.end_kwh
            })));

            setDailyLoading(false);
        } catch (error) {
            console.error("Error fetching daily report:", error);
            setDailyLoading(false);
        }
    };

    const rowsdailyPerPage = 10;
    const totaldailyPages = Math.ceil((dailyreportData?.length || 0) / rowsdailyPerPage);

    const indexOfdailyLastRow = currentdailyreportPage * rowsdailyPerPage;
    const indexOfdailyFirstRow = indexOfdailyLastRow - rowsdailyPerPage;
    const currentDailyRows = dailyreportData?.slice(indexOfdailyFirstRow, indexOfdailyLastRow) || [];

    const handledailyPageChange = (newPage) => {
        setCurrentdailyreportPage(newPage);
    };


    const handleDailyExportToExcel = async (data, fileName) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Daily Report');

        const getBase64FromImageUrl = async (url) => {
            const response = await fetch(url);
            const blob = await response.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result.split(',')[1]);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        };

        for (let rowNum = 1; rowNum <= 3; rowNum++) {
            const row = worksheet.getRow(rowNum);
            for (let i = 1; i <= 7; i++) {
                row.getCell(i).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFDDDDDD' },
                };
            }
        }

        try {
            const logoBase64 = await getBase64FromImageUrl('/brad.png');
            const logoId = workbook.addImage({
                base64: logoBase64,
                extension: 'png'
            });

            const centerCol = Math.floor(7 / 2) - 1;
            worksheet.addImage(logoId, {
                tl: { col: centerCol + 1, row: 0 },
                br: { col: centerCol + 2, row: 3 },
                editAs: 'oneCell'
            });

            worksheet.getRow(1).height = 30;
            worksheet.getRow(2).height = 30;
            worksheet.getRow(3).height = 30;

            worksheet.getColumn(centerCol + 1).width = 30;
            worksheet.getColumn(centerCol + 2).width = 30;
        } catch (error) {
            console.error('Error adding logo:', error);
        }

        // Set column widths
        worksheet.getColumn(1).width = 20; // Meter Name
        worksheet.getColumn(2).width = 15; // Meter ID
        worksheet.getColumn(3).width = 15; // Start KWh
        worksheet.getColumn(4).width = 20; // End KWh
        worksheet.getColumn(5).width = 15; // Co2
        worksheet.getColumn(6).width = 15; // Total KWH
        worksheet.getColumn(7).width = 15; // Total Cost

        // Add date header
        const dateRow = worksheet.addRow([`Report Date: ${dailyDate}`]);
        worksheet.mergeCells(dateRow.number, 1, dateRow.number, 7);
        dateRow.font = { bold: true, size: 14 };
        dateRow.alignment = { horizontal: 'center', vertical: 'middle' };

        [1, 2, 3, 4, 5, 6, 7].forEach((col) => {
            worksheet.getCell(dateRow.number, col).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' },
            };
        });

        // Add branch info
        const branchRow = worksheet.addRow(['Site: Coimbatore', '', '', '', '', '', '']);
        branchRow.font = { bold: true, size: 12 };
        branchRow.getCell(1).alignment = { horizontal: 'left' };
        branchRow.getCell(7).alignment = { horizontal: 'center' };
        [1, 2, 3, 4, 5, 6, 7].forEach((col) => {
            worksheet.getCell(branchRow.number, col).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9D9D9' },
            };
        });

        // Add title
        const titleRow = worksheet.addRow(['Daily Log View']);
        worksheet.mergeCells(titleRow.number, 1, titleRow.number, 7);
        titleRow.font = { bold: true, size: 16 };
        titleRow.alignment = { horizontal: 'center', vertical: 'middle' };

        [1, 2, 3, 4, 5, 6, 7].forEach((col) => {
            worksheet.getCell(titleRow.number, col).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF1E90FF' },
            };
        });

        // Add headers
        const headers = ['Meter Name', 'Meter ID', 'Start KWh', 'End KWh', 'Total KWH', 'Total Cost', 'Co2'];
        const headerRow = worksheet.addRow(headers);
        headerRow.font = { bold: true };
        headerRow.eachCell((cell) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' },
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        // Add data rows
        data.forEach((row, index) => {
            const rowData = [
                row.meter_name,
                row.meter_id,
                row.startKwh,
                row.endKwh,
                row.totalKwh.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                row.totalCost.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                row.totalCo2.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            ];
            const dataRow = worksheet.addRow(rowData);
            dataRow.eachCell((cell, colIndex) => {
                const fillColor = index % 2 === 0 ? 'FFE8EAF6' : 'FFFFFFFF';
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: fillColor },
                };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
        });

        // Add totals row
        const totalRow = worksheet.addRow([
            '', '', '', 'TOTAL',
            data.reduce((total, row) => total + row.totalKwh, 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            data.reduce((total, row) => total + row.totalCost, 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }), ''
        ]);
        totalRow.font = { bold: true };
        totalRow.eachCell((cell) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' },
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        // Add footer
        const footerRow = worksheet.addRow(['Powered by Innospace']);
        footerRow.font = { bold: true, size: 12 };
        footerRow.alignment = { horizontal: 'center', vertical: 'middle' };
        worksheet.mergeCells(footerRow.number, 1, footerRow.number, 7);

        [1, 2, 3, 4, 5, 6, 7].forEach((col) => {
            worksheet.getCell(footerRow.number, col).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFDDDDDD' },
            };
        });

        // Download file
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
        });
    };

    const handleMonthlyReport = async () => {
        setMonthlyLoading(true);
        setCurrentmonthlyreportPage(1);
        try {
            const formatDate = (date) => {
                const month = date.getMonth() + 1;
                const year = date.getFullYear();
                return `${year}-${month < 10 ? '0' + month : month}`;
            };

            const formattedFromDate = formatDate(monthlyfromDate);

            const response = await axios.post(`${BaseURL}data/group-monthly-report/`, {
                month_year: formattedFromDate,
                group_name: group_name
            });

            const data = response.data;
            const formattedData = data.meters.map(meter => ({
                month: data.month,
                meterID: meter.meter_id,
                meterName: meter.meter_name,
                startKwh: meter.start_kwh,
                endKwh: meter.end_kwh,
                totalKwh: meter.consumption_kwh,
                unitRate: meter.unit_rate,
                totalCost: meter.cost,
                totalCo2: meter.co2
            }));

            setMonthsData(formattedData);

            setMonthlyLoading(false);
        } catch (error) {
            console.error("Error fetching monthly report:", error);
            setMonthlyLoading(false);
        }
    };

    const rowsmonthlyPerPage = 10;

    const totalmonthlyPages = Math.ceil(monthsData.length / rowsmonthlyPerPage);

    const indexOfmonthlyLastRow = currentmonthlyreportPage * rowsmonthlyPerPage;
    const indexOfmonthlyFirstRow = indexOfmonthlyLastRow - rowsmonthlyPerPage;
    const currentMonthlyRows = monthsData.slice(indexOfmonthlyFirstRow, indexOfmonthlyLastRow);

    const handlemonthlyPageChange = (newPage) => {
        setCurrentmonthlyreportPage(newPage);
    };

    const handleMonthlyFromMonthChange = (date) => {
        setmonthlyFromDate(date);
    };

    const handleExportToExcel = async (data, fileName) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Monthly Report');

        const getBase64FromImageUrl = async (url) => {
            const response = await fetch(url);
            const blob = await response.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result.split(',')[1]);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        };

        for (let rowNum = 1; rowNum <= 3; rowNum++) {
            const row = worksheet.getRow(rowNum);
            for (let i = 1; i <= 8; i++) {
                row.getCell(i).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFDDDDDD' },
                };
            }
        }

        try {
            const logoBase64 = await getBase64FromImageUrl('/brad.png');
            const logoId = workbook.addImage({
                base64: logoBase64,
                extension: 'png'
            });

            const centerCol = Math.floor(7 / 2) - 1;
            worksheet.addImage(logoId, {
                tl: { col: centerCol + 1, row: 0 },
                br: { col: centerCol + 2, row: 3 },
                editAs: 'oneCell'
            });

            worksheet.getRow(1).height = 30;
            worksheet.getRow(2).height = 30;
            worksheet.getRow(3).height = 30;

            worksheet.getColumn(centerCol + 1).width = 30;
            worksheet.getColumn(centerCol + 2).width = 30;
        } catch (error) {
            console.error('Error adding logo:', error);
        }

        // Set column widths
        worksheet.getColumn(1).width = 10;  // S.No
        worksheet.getColumn(2).width = 15;  // Meter ID
        worksheet.getColumn(3).width = 20;  // Meter Name
        worksheet.getColumn(4).width = 15;  // Start KWh
        worksheet.getColumn(5).width = 15;  // End KWh
        worksheet.getColumn(6).width = 15;  // CO2
        worksheet.getColumn(7).width = 15;  // KWh
        worksheet.getColumn(8).width = 15;  // Total Cost

        // Add date header
        const monthYear = monthlyfromDate ? monthlyfromDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' }) : "Selected Month";
        const dateRow = worksheet.addRow([`Monthly Report for ${group_name} - ${monthYear}`]);
        worksheet.mergeCells(dateRow.number, 1, dateRow.number, 8);
        dateRow.font = { bold: true, size: 14 };
        dateRow.alignment = { horizontal: 'center', vertical: 'middle' };

        [1, 2, 3, 4, 5, 6, 7, 8].forEach((col) => {
            worksheet.getCell(dateRow.number, col).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' },
            };
        });

        // Add branch info
        const branchRow = worksheet.addRow(['Site: Coimbatore', '', '', '', '', '', '']);
        branchRow.font = { bold: true, size: 12 };
        worksheet.getColumn(1).width = 20;
        worksheet.getColumn(8).width = 30;
        branchRow.getCell(1).alignment = { horizontal: 'left' };
        branchRow.getCell(8).alignment = { horizontal: 'center' };
        [1, 2, 3, 4, 5, 6, 7, 8].forEach((col) => {
            worksheet.getCell(branchRow.number, col).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9D9D9' },
            };
        });

        // Add title
        const titleRow = worksheet.addRow(['Monthly Energy Report']);
        worksheet.mergeCells(titleRow.number, 1, titleRow.number, 8);
        titleRow.font = { bold: true, size: 16 };
        titleRow.alignment = { horizontal: 'center', vertical: 'middle' };

        [1, 2, 3, 4, 5, 6, 7, 8].forEach((col) => {
            worksheet.getCell(titleRow.number, col).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF1E90FF' },
            };
        });

        // Add headers
        const headers = ['S.No', 'Meter ID', 'Meter Name', 'Start KWh', 'End KWh', 'KWh', 'Total Cost', 'CO2'];
        const headerRow = worksheet.addRow(headers);
        headerRow.font = { bold: true };
        headerRow.eachCell((cell) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' },
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        // Add data rows
        data.forEach((item, index) => {
            const rowData = [
                index + 1,
                item.meterID,
                item.meterName,
                item.startKwh.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.endKwh.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalKwh.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalCost.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.totalCo2.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            ];
            const dataRow = worksheet.addRow(rowData);
            dataRow.eachCell((cell, colIndex) => {
                const fillColor = index % 2 === 0 ? 'FFE8EAF6' : 'FFFFFFFF';
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: fillColor },
                };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
        });

        // Add totals row
        const totalRow = worksheet.addRow([
            '', '', '', '', 'TOTAL',
            data.reduce((total, item) => total + item.totalKwh, 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            data.reduce((total, item) => total + item.totalCost, 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }), ''
        ]);
        totalRow.font = { bold: true };
        totalRow.eachCell((cell) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' },
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        // Add footer
        const footerRow = worksheet.addRow(['Powered by Innospace']);
        footerRow.font = { bold: true, size: 12 };
        footerRow.alignment = { horizontal: 'center', vertical: 'middle' };
        worksheet.mergeCells(footerRow.number, 1, footerRow.number, 8);

        [1, 2, 3, 4, 5, 6, 7, 8].forEach((col) => {
            worksheet.getCell(footerRow.number, col).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFDDDDDD' },
            };
        });

        // Download file
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
        });
    };

    const generateFilename = () => {
        const formattedFromDate = monthlyfromDate
            ? monthlyfromDate.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit' })
            : "FromDate";

        return `Monthly_Report_${formattedFromDate}.xlsx`;
    };

    return (
        <div className="dashboard-container">
            <Header title="BRADKEN ENERGY MANAGEMENT DASHBOARD" />

            <div className="card-container" style={{
                border: '1px solid #ccc',
                borderRadius: '10px',
                padding: '20px',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                backgroundColor: '#fff',
                marginTop: '50px',
                maxWidth: '1000px',
                marginLeft: 'auto',
                marginRight: 'auto'
            }}>
                <h3 className="dashboard-subtitle"><span onClick={() => navigate('/EMS/group-portal')} style={{ color: '#007bff', cursor: 'pointer' }} title="Navigate to Group Portal">MAIN</span> {' / '} {group_name}</h3>
                {/* <div className="widgets-container" style={{ display: 'grid',  gap: '20px', marginBottom: '20px' }}> */}
                <div className="widgets-container" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px', marginBottom: '20px' }}>

                    <div className="widget-container" style={{ width: '100%' }}>
                        <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                            <h3>Today's</h3>
                            <div style={{ display: 'table', width: '100%' }}>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Energy</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{loading ? (
                                        <div className="spinner"></div>
                                    ) : (
                                        `${widgetData.today[0].toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} kWh`
                                    )}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Cost</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{loading ? (
                                        <div className="spinner"></div>
                                    ) : (
                                        `Rs ${widgetData.today[1].toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`
                                    )}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Co2</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{loading ? (
                                        <div className="spinner"></div>
                                    ) : (
                                        `${widgetData.today[2].toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} Tons`
                                    )}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="widget-container" style={{ width: '100%' }}>
                        <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', background: 'linear-gradient(145deg, #4caf50, #2b9e36)', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                            <h3>Yesterday</h3>
                            <div style={{ display: 'table', width: '100%' }}>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Energy</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{loading ? (
                                        <div className="spinner"></div>
                                    ) : (
                                        `${widgetData.yesterday[0].toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} kWh`
                                    )}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Cost</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{loading ? (
                                        <div className="spinner"></div>
                                    ) : (
                                        `Rs ${widgetData.yesterday[1].toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`
                                    )}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Co2</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{loading ? (
                                        <div className="spinner"></div>
                                    ) : (
                                        `${widgetData.yesterday[2].toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} Tons`
                                    )}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="widget-container" style={{ width: '100%' }}>
                        <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', background: 'linear-gradient(145deg, #2196f3, #0b7dda)', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                            <h3>Current Month</h3>
                            <div style={{ display: 'table', width: '100%' }}>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Energy</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{loading ? (
                                        <div className="spinner"></div>
                                    ) : (
                                        `${widgetData.currentMonth[0].toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} kWh`
                                    )}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Cost</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{loading ? (
                                        <div className="spinner"></div>
                                    ) : (
                                        `Rs ${widgetData.currentMonth[1].toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`
                                    )}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Co2</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{loading ? (
                                        <div className="spinner"></div>
                                    ) : (
                                        `${widgetData.currentMonth[2].toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} Tons`
                                    )}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="widget-container" style={{ width: '100%' }}>
                        <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', background: 'linear-gradient(145deg, #ed76fd, #e53afd)', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                            <h3>Last Month</h3>
                            <div style={{ display: 'table', width: '100%' }}>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Energy</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{loading ? (
                                        <div className="spinner"></div>
                                    ) : (
                                        `${widgetData.lastMonth[0].toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} kWh`
                                    )}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Cost</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{loading ? (
                                        <div className="spinner"></div>
                                    ) : (
                                        `Rs ${widgetData.lastMonth[1].toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`
                                    )}</p>
                                </div>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Co2</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>{loading ? (
                                        <div className="spinner"></div>
                                    ) : (
                                        `${widgetData.lastMonth[2].toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} Tons`
                                    )}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="widget-container" style={{ width: '20%', marginLeft:'350px' }}>
                        <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                            <h3>Total No of Meters</h3>
                            <div style={{ display: 'table', width: '100%', height: '30px' }}>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'center', marginBottom: '20px' }}>{submachines.length}</p>
                                </div>
                            </div>
                        </div>
                    </div> */}
                {/* </div> */}
                {/* <div
            style={{
                width: "96%",
                margin: "20px auto",
                padding: "20px",
                border: "1px solid #ccc",
                borderRadius: "10px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                backgroundColor: "#fff",
            }}
            >
            <h4>
                Time Slots
            </h4>

            <div
        style={{
            flexDirection: "row",
            alignItems: "center",
            marginBottom: "30px",
            marginLeft: "150px"
        }}
      >
       
        <label
          style={{
            fontSize: "14px",
            color: "#333",
            marginBottom: "5px", 
            fontWeight: "bold",
          }}
        >
         Date:
        </label>
        <DatePicker
          selected={timeselectedDate}
          onChange={handleTimeDateChange}
          dateFormat="yyyy/MM/dd"
          customInput={
            <input
              style={{
                fontSize: "12px",
                width:'35%',
                marginRight:'140px'
              }}
            />
          }
        />
      </div>

            <div
                style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "30px",
                }}
                
            >
                <Chart
                    options={chartsData.options}
                    series={chartsData.series}
                    type="bar"
                    height={350}
                    width={800}
                />
            </div>

            <table
                style={{
                width: "100%",
                borderCollapse: "collapse",
                textAlign: "center",
                }}
            >
                <thead>
                <tr>
                    <th
                    style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        backgroundColor: "#f4f4f4",
                    }}
                    >
                    Timings
                    </th>
                    <th
                    style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        backgroundColor: "#f4f4f4",
                    }}
                    >
                    Rate
                    </th>
                    <th
                    style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        backgroundColor: "#f4f4f4",
                    }}
                    >
                    Today's Wh
                    </th>
                    <th
                    style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        backgroundColor: "#f4f4f4",
                    }}
                    >
                    Total Cost
                    </th>
                </tr>
                </thead>
                <tbody>
                {tableData.map((row, index) => (
                    <tr key={index}>
                    <td
                        style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        }}
                    >
                        {row.Timings}
                    </td>
                    <td
                        style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        }}
                    >
                        Rs {row.Rate.toLocaleString()}
                    </td>
                    <td
                        style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        }}
                    >
                        {row.TodaysKWhr.toLocaleString()}
                    </td>
                    <td
                        style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        }}
                    >
                        Rs {row.TotalCost.toLocaleString()}
                    </td>
                    </tr>
                ))}
                <tr>
                    <td
                    style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        fontWeight: "bold",
                        backgroundColor: "#f9f9f9",
                    }}
                    colSpan={2}
                    >
                    Total
                    </td>
                    <td
                    style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        fontWeight: "bold",
                        backgroundColor: "#f9f9f9",
                    }}
                    >
                    {totalKWhr.toLocaleString()}
                    </td>
                    <td
                    style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        fontWeight: "bold",
                        backgroundColor: "#f9f9f9",
                    }}
                    >
                    Rs {totalCost.toLocaleString()}
                    </td>
                </tr>
                </tbody>
            </table>
        </div> */}
                <div
                    className="card-container"
                    style={{
                        border: "1px solid #ccc",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                        backgroundColor: "#fff",
                        marginTop: "30px",
                        maxWidth: "1000px",
                        marginLeft: "auto",
                        marginRight: "auto",
                        marginBottom: '20px',
                        padding: "10px",
                        borderRadius: "10px",
                    }}
                >
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        marginBottom: '20px',
                    }}>
                        <div style={{
                            width: '300px',
                            height: '300px',
                            marginBottom: '20px',
                        }}>
                            <Pie
                                data={pieChartData}
                                options={{
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        legend: {
                                            display: false,
                                            position: 'bottom',
                                        },
                                        tooltip: {
                                            callbacks: {
                                                label: function (tooltipItem) {
                                                    const value = tooltipItem.raw.toFixed(2);
                                                    return `${tooltipItem.label}: ${value}%`;
                                                },
                                            },
                                        },
                                    },
                                }}
                            />
                        </div>
                    </div>
                    <table
                        className="sub-meters-table"
                        style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            textAlign: "center",
                        }}
                    >
                        <thead>
                            <tr>
                                <th
                                    style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                        backgroundColor: "#f4f4f4",
                                    }}
                                >
                                    S.NO
                                </th>
                                <th
                                    style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                        backgroundColor: "#f4f4f4",
                                    }}
                                >
                                    Meter Name
                                </th>
                                <th
                                    style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                        backgroundColor: "#f4f4f4",
                                    }}
                                >
                                    Meter ID
                                </th>
                                <th
                                    style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                        backgroundColor: "#f4f4f4",
                                    }}
                                >
                                    Group
                                </th>
                                <th
                                    style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                        backgroundColor: "#f4f4f4",
                                    }}
                                >
                                    Today's kWh
                                </th>
                                <th
                                    style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                        backgroundColor: "#f4f4f4",
                                    }}
                                >
                                    Total Cost
                                </th>
                                <th style={{
                                    border: "1px solid #ddd",
                                    padding: "8px",
                                    backgroundColor: "#f4f4f4",
                                }}
                                >
                                    Unit %
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentMachines.map((submachine, index) => (
                                <tr
                                    key={submachine.meter_id}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleMeterClick(submachine.meter_id, submachine.group_name)}
                                >
                                    <td
                                        style={{
                                            border: "1px solid #ddd",
                                            padding: "8px",
                                        }}
                                    >
                                        {index + 1 + (currentPage - 1) * itemsPerPage}
                                    </td>
                                    <td
                                        style={{
                                            border: "1px solid #ddd",
                                            padding: "8px",
                                        }}
                                    >
                                        {submachine.meter_name}
                                    </td>
                                    <td
                                        style={{
                                            border: "1px solid #ddd",
                                            padding: "8px",
                                        }}
                                    >
                                        {submachine.meter_id}
                                    </td>
                                    <td
                                        style={{
                                            border: "1px solid #ddd",
                                            padding: "8px",
                                        }}
                                    >
                                        {submachine.group_name}
                                    </td>
                                    <td
                                        style={{
                                            border: "1px solid #ddd",
                                            padding: "8px",
                                            textAlign: "right",
                                        }}
                                    >
                                        {loadingFlags[index] || submachine.total_kWh === undefined
                                            ? <span className="table-spinner"></span>
                                            : submachine.total_kWh.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                    </td>
                                    <td
                                        style={{
                                            border: "1px solid #ddd",
                                            padding: "8px",
                                            textAlign: "right",
                                        }}
                                    >
                                        {loadingFlags[index] || submachine.total_cost === undefined
                                            ? <span className="table-spinner"></span>
                                            : `Rs ${submachine.total_cost.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`}
                                    </td>
                                    <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                                        <div
                                            style={{
                                                width: '20px',
                                                height: '20px',
                                                backgroundColor: getColorForMachine(index),
                                                borderRadius: '50%',
                                                display: 'inline-block',
                                                marginRight: '8px',
                                            }}
                                        ></div>
                                        <span>{kWhPercentagesForPie[index + indexOfFirstMachine].toFixed(2)}%</span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td
                                    colSpan="4"
                                    style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                        fontWeight: "bold",
                                        backgroundColor: "#f9f9f9",
                                    }}
                                >
                                    Total
                                </td>
                                <td
                                    style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                        fontWeight: "bold",
                                        backgroundColor: "#f9f9f9",
                                        textAlign: "right",
                                    }}
                                >
                                    {submachines.reduce((total, submachine) => total + submachine.total_kWh, 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                </td>
                                <td
                                    style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                        fontWeight: "bold",
                                        backgroundColor: "#f9f9f9",
                                        textAlign: "right",
                                    }}
                                >
                                    Rs {submachines.reduce((total, submachine) => total + submachine.total_cost, 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                </td>
                                <td
                                    style={{
                                        border: "1px solid #ddd",
                                        padding: "8px",
                                        fontWeight: "bold",
                                        backgroundColor: "#f9f9f9",
                                        textAlign: "right",
                                    }}
                                >

                                </td>
                            </tr>
                        </tfoot>
                    </table>
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                        <button
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                            style={{
                                marginRight: '10px',
                                padding: '5px 10px',
                                background: currentPage === 1 ? '#007acc' : '#007acc',
                                border: 'none',
                                borderRadius: '25px',
                                color: 'white',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease',
                                boxShadow: currentPage === 1 ? 'none' : '0px 4px 8px rgba(0, 0, 0, 0.2)',
                                fontSize: '12px',
                            }}
                        >
                            Previous
                        </button>

                        {Array.from({ length: totalPages }, (_, i) => (
                            <button
                                key={i}
                                onClick={() => paginate(i + 1)}
                                style={{
                                    margin: '0 5px',
                                    padding: '5px 10px',
                                    background: currentPage === i + 1 ? '#007acc' : 'linear-gradient(to right, #f7f7f7, #e0e0e0)',
                                    color: currentPage === i + 1 ? '#ffffff' : '#333333',
                                    border: '1px solid #ddd',
                                    borderRadius: '25px',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    transition: 'background-color 0.3s ease',
                                }}
                            >
                                {i + 1}
                            </button>
                        ))}

                        <button
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            style={{
                                marginLeft: '10px',
                                padding: '5px 10px',
                                background: currentPage === totalPages ? '#007acc' : '#007acc',
                                border: 'none',
                                borderRadius: '25px',
                                color: 'white',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease',
                                boxShadow: currentPage === totalPages ? 'none' : '0px 4px 8px rgba(0, 0, 0, 0.2)',
                                fontSize: '12px',
                            }}
                        >
                            Next
                        </button>
                    </div>
                </div>
                <div
                    className="extra-details-row"
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: '20px',
                    }}
                >
                </div>
                <div className="charts-container" style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div
                        className="container-4"
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#f9f0f3',
                            marginTop: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <h4>Hourly Data</h4>
                        <div style={{ marginBottom: "20px" }}>
                            <label
                                htmlFor="date-picker"
                                style={{
                                    alignItems: "center",
                                    marginBottom: "20px",
                                }}
                            >
                                Date:
                            </label>
                            <DatePicker
                                id="date-picker"
                                selected={selectedDate}
                                onChange={(date) => setSelectedDate(date)}
                                dateFormat="yyyy/MM/dd"
                                customInput={
                                    <input
                                        style={{
                                            fontSize: "12px",
                                            width: '55%',
                                        }}
                                    />
                                }
                            />
                        </div>
                        {/* <div style={{ marginBottom: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <h5>Select Bar Colors</h5>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                            <label style={{ marginRight: '10px' }}>Background:</label>
                            <input
                                type="color"
                                value={containerColor}
                                onChange={(e) => setContainerColor(e.target.value)}
                            />
                            <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{containerColor}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                            <label style={{ marginRight: '10px' }}>KWh:</label>
                            <input
                                type="color"
                                value={hourlychartColors.kWh}
                                onChange={(e) => handleColorChange('kWh', e.target.value)}
                            />
                            <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{hourlychartColors.kWh}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                            <label style={{ marginRight: '10px' }}>Cost:</label>
                            <input
                                type="color"
                                value={hourlychartColors.cost}
                                onChange={(e) => handleColorChange('cost', e.target.value)}
                            />
                            <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{hourlychartColors.cost}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <label style={{ marginRight: '10px' }}>CO2:</label>
                            <input
                                type="color"
                                value={hourlychartColors.co2}
                                onChange={(e) => handleColorChange('co2', e.target.value)}
                            />
                            <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{hourlychartColors.co2}</span>
                        </div>
                    </div>
                </div> */}
                        <Chart
                            options={{
                                chart: {
                                    type: 'bar',
                                    height: 350,
                                    backgroundColor: '#f9f0f3',
                                    toolbar: {
                                        tools: {
                                            download: false
                                        },
                                    },
                                },
                                plotOptions: {
                                    bar: {
                                        horizontal: false,
                                        columnWidth: '50%',
                                        endingShape: 'rounded',
                                    },
                                },
                                colors: ['#1a27db', '#1ff4ad', '#ffc107'],
                                dataLabels: {
                                    enabled: false,
                                },
                                xaxis: {
                                    categories: categorie,
                                    title: {
                                        text: 'Time of Day',
                                    },
                                },
                                yaxis: {
                                    title: {
                                        text: 'kWh',
                                    },
                                    labels: {
                                        formatter: (value) => {
                                            return new Intl.NumberFormat('en-US', {
                                                maximumFractionDigits: 0,
                                                minimumFractionDigits: 0
                                            }).format(value);
                                        },
                                    },
                                },
                                legend: {
                                    position: 'top',
                                    horizontalAlign: 'center',
                                    offsetX: 0,
                                    offsetY: 0,
                                },
                            }}
                            series={[
                                {
                                    name: 'kWh',
                                    data: chartDatas.kWh,
                                },
                                {
                                    name: 'Cost',
                                    data: chartDatas.cost,
                                },
                                {
                                    name: 'CO₂',
                                    data: chartDatas.co2,
                                },
                            ]}
                            type="bar"
                            height={350}
                            width={950}
                        />
                    </div>
                </div>
                <div
                    className="charts-container"
                    style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', width: '100%' }}
                >
                    <div
                        className="container-4"
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#fbe9f6',
                            marginTop: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <h4>Day's Consumption</h4>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginBottom: "30px",
                            }}
                        >
                            <label
                                style={{
                                    fontSize: "14px",
                                    color: "#333",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Month:
                            </label>
                            <select
                                value={selectedMonth}
                                onChange={handleMonthChange}
                                style={{
                                    padding: "5px",
                                    marginRight: "20px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                {monthNames.map((month, index) => (
                                    <option key={index + 1} value={index + 1}>
                                        {month}
                                    </option>
                                ))}
                            </select>

                            <label
                                style={{
                                    fontSize: "14px",
                                    color: "#333",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Year:
                            </label>
                            <select
                                value={selectedYear}
                                onChange={handleYearChange}
                                style={{
                                    padding: "5px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(year => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {/* <div style={{ marginBottom: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <h5>Select Bar Colors</h5>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                            <label style={{ marginRight: '10px' }}>Background:</label>
                            <input
                                type="color"
                                value={daycontainerColor}
                                onChange={(e) => setdayContainerColor(e.target.value)}
                            />
                            <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{daycontainerColor}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                            <label style={{ marginRight: '10px' }}>KWh:</label>
                            <input
                                type="color"
                                value={dayschartColors.kWh}
                                onChange={(e) => handledaysColorChange('kWh', e.target.value)}
                            />
                            <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{dayschartColors.kWh}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                            <label style={{ marginRight: '10px' }}>Cost:</label>
                            <input
                                type="color"
                                value={dayschartColors.cost}
                                onChange={(e) => handledaysColorChange('cost', e.target.value)}
                            />
                            <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{dayschartColors.cost}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <label style={{ marginRight: '10px' }}>CO2:</label>
                            <input
                                type="color"
                                value={dayschartColors.co2}
                                onChange={(e) => handledaysColorChange('co2', e.target.value)}
                            />
                            <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{dayschartColors.co2}</span>
                        </div>
                    </div>
                </div> */}
                        <Chart
                            options={{
                                chart: {
                                    type: 'bar',
                                    height: 350,
                                    backgroundColor: '#fbe9f6',
                                    toolbar: {
                                        tools: {
                                            zoom: false,
                                            zoomin: false,
                                            zoomout: false,
                                            pan: false,
                                            reset: false,
                                            download: false,
                                        },
                                    },
                                    zoom: {
                                        enabled: true,
                                    },
                                },
                                plotOptions: {
                                    bar: {
                                        horizontal: false,
                                        columnWidth: '50%',
                                        endingShape: 'rounded',
                                    },
                                },
                                colors: ['#ff47f0', '#3743e6', '#00ced1'],
                                dataLabels: {
                                    enabled: false,
                                },
                                xaxis: {
                                    categories: dailyData.categories,
                                    title: {
                                        text: 'Dates',
                                    },
                                },
                                yaxis: {
                                    title: {
                                        text: 'kWh',
                                    },
                                    labels: {
                                        formatter: (value) => {
                                            return new Intl.NumberFormat('en-US', {
                                                maximumFractionDigits: 0,
                                                minimumFractionDigits: 0
                                            }).format(value);
                                        },
                                    },
                                },
                                legend: {
                                    position: 'top',
                                    horizontalAlign: 'center',
                                    offsetX: 0,
                                    offsetY: 0,
                                },
                                tooltip: {
                                    y: {
                                        formatter: function (value, { seriesIndex }) {
                                            if (seriesIndex === 1) {
                                                return `Rs ${value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                                            }
                                            return value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
                                        },
                                    },
                                },
                            }}
                            series={[
                                {
                                    name: 'kWh',
                                    data: dailyData.kw,
                                },
                                {
                                    name: 'Cost',
                                    data: dailyData.cost,
                                },
                                {
                                    name: 'CO₂',
                                    data: dailyData.co2,
                                },
                            ]}
                            type="bar"
                            height={350}
                            width={950}
                        />
                    </div>
                </div>
                <div className="charts-container" style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div
                        className="container-4"
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#f0fbff',
                            marginTop: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <h4>Monthly Consumption</h4>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginBottom: "30px",
                            }}
                        >
                            <label
                                style={{
                                    fontSize: "14px",
                                    color: "#333",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Year:
                            </label>
                            <select
                                value={selectedNewYear}
                                onChange={handleNewYearChange}
                                style={{
                                    padding: "5px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(year => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {/* <div style={{ marginBottom: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <h5>Select Bar Colors</h5>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                            <label style={{ marginRight: '10px' }}>Background:</label>
                            <input
                                type="color"
                                value={monthcontainerColor}
                                onChange={(e) => setmonthContainerColor(e.target.value)}
                            />
                            <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{monthcontainerColor}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                            <label style={{ marginRight: '10px' }}>KWh:</label>
                            <input
                                type="color"
                                value={monthlychartColors.kWh}
                                onChange={(e) => handlemonthlyColorChange('kWh', e.target.value)}
                            />
                            <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{monthlychartColors.kWh}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                            <label style={{ marginRight: '10px' }}>Cost:</label>
                            <input
                                type="color"
                                value={monthlychartColors.cost}
                                onChange={(e) => handlemonthlyColorChange('cost', e.target.value)}
                            />
                            <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{monthlychartColors.cost}</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <label style={{ marginRight: '10px' }}>CO2:</label>
                            <input
                                type="color"
                                value={monthlychartColors.co2}
                                onChange={(e) => handlemonthlyColorChange('co2', e.target.value)}
                            />
                            <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>{monthlychartColors.co2}</span>
                        </div>
                    </div>
                </div> */}
                        <Chart
                            options={{
                                chart: {
                                    type: 'bar',
                                    height: 350,
                                    backgroundColor: '#f0fbff',
                                    toolbar: {
                                        tools: {
                                            zoom: false,
                                            zoomin: false,
                                            zoomout: false,
                                            pan: false,
                                            reset: false,
                                            download: false,
                                        },
                                    },
                                    zoom: {
                                        enabled: true,
                                    },
                                },
                                plotOptions: {
                                    bar: {
                                        horizontal: false,
                                        columnWidth: '50%',
                                        endingShape: 'rounded',
                                    },
                                },
                                colors: ['#a71606', '#2ced7f', '#1e90ff'],
                                dataLabels: {
                                    enabled: false,
                                },
                                xaxis: {
                                    categories: monthlyData.categories,
                                    title: {
                                        text: 'Months',
                                    },
                                },
                                yaxis: {
                                    title: {
                                        text: 'kWh',
                                    },
                                    labels: {
                                        formatter: (value) => {
                                            return new Intl.NumberFormat('en-US', {
                                                maximumFractionDigits: 0,
                                                minimumFractionDigits: 0
                                            }).format(value);
                                        },
                                    },
                                },
                                legend: {
                                    position: 'top',
                                    horizontalAlign: 'center',
                                    offsetX: 0,
                                    offsetY: 0,
                                },
                                tooltip: {
                                    y: {
                                        formatter: function (value, { seriesIndex }) {
                                            if (seriesIndex === 1) {
                                                return `Rs ${value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                                            }
                                            return value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
                                        },
                                    },
                                },
                            }}
                            series={[
                                {
                                    name: 'kWh',
                                    data: monthlyData.kWh,
                                },
                                {
                                    name: 'Cost',
                                    data: monthlyData.cost,
                                },
                                {
                                    name: 'CO₂',
                                    data: monthlyData.co2,
                                },
                            ]}
                            type="bar"
                            height={350}
                            width={950}
                        />
                    </div>
                </div>
            </div>
            <div className="dashboard">
                <div className="main-container">
                    <h4>Reports</h4>
                    <div className="nav-bar">
                        {tabs.map((tab) => (
                            <button
                                key={tab}
                                className={activeTab === tab ? "active" : ""}
                                onClick={() => handleTabChange(tab)}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                    {activeTab === "Daily" && (
                        <div className="daily-report-production">
                            <div className="card controls-card">
                                <input
                                    type="date"
                                    value={dailyDate}
                                    onChange={(e) => setDailyDate(e.target.value)}
                                    placeholder="Select Date"
                                />
                                <button onClick={handleGetDailyReport}>Get Report</button>
                                <button
                                    onClick={() => {
                                        const fileName = `Daily_Report_${dailyDate}.xlsx`;
                                        handleDailyExportToExcel(dailyreportData, fileName);
                                    }}
                                >
                                    <i className="excel-icon">📊</i> Excel
                                </button>
                            </div>
                            {dailyloading ? (
                                <span className="spinner" />
                            ) : (
                                <div className="table-container">
                                    <h4 className="table-title">
                                        Daily Log View for {dailyDate}
                                    </h4>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Meter Name</th>
                                                <th>Meter ID</th>
                                                <th>Start kWh</th>
                                                <th>End kWh</th>
                                                
                                                <th>Total kWh</th>
                                                <th>Total Cost</th>
                                                <th>CO₂</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentDailyRows.length > 0 ? (
                                                currentDailyRows.map((row, index) => (
                                                    <tr key={index}>
                                                        <td>{row.meter_name}</td>
                                                        <td>{row.meter_id}</td>
                                                        <td>{row.startKwh}</td>
                                                        <td>{row.endKwh}</td>
                                                        
                                                        <td>{row.totalKwh.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                                                        <td>{row.totalCost.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                                                        <td>{row.totalCo2.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" style={{ textAlign: "center" }}>
                                                        No Data Available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: "right" }}>TOTAL</td>
                                                <td>{dailyreportData.reduce((total, row) => total + row.totalKwh, 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                                                <td>{dailyreportData.reduce((total, row) => total + row.totalCost, 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                                                <td></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            )}
                            <div className="pagination-controls">
                                <button
                                    disabled={currentdailyreportPage === 1 || currentDailyRows.length === 0}
                                    onClick={() => handledailyPageChange(currentdailyreportPage - 1)}
                                >
                                    Previous
                                </button>
                                <span>  {currentdailyreportPage}   of   {totaldailyPages}  </span>
                                <button
                                    disabled={currentdailyreportPage === totaldailyPages || currentDailyRows.length === 0}
                                    onClick={() => handledailyPageChange(currentdailyreportPage + 1)}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    )}
                    {activeTab === "Monthly" && (
                        <div className="Monthly-Report">
                            <div className="card controls-card">
                                <DatePicker
                                    selected={monthlyfromDate}
                                    onChange={handleMonthlyFromMonthChange}
                                    dateFormat="yyyy-MM"
                                    showMonthYearPicker
                                    placeholderText="Select Month"
                                    className="custom-date-picker"
                                />
                                <button onClick={handleMonthlyReport}>Get Report</button>
                                <button
                                    onClick={() => handleExportToExcel(monthsData, generateFilename())}
                                >
                                    <i className="excel-icon">📊</i> Excel
                                </button>
                            </div>
                            {monthlyloading ? (
                                <div>
                                    <span className="spinner"></span>
                                </div>
                            ) : (
                                <div className="table-container">
                                    <h4 className="table-title">
                                        Monthly Report for {group_name} - {monthlyfromDate ? monthlyfromDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' }) : "Selected Month"}
                                    </h4>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Meter ID</th>
                                                <th>Meter Name</th>
                                                <th>Start kWh</th>
                                                <th>End kWh</th>
                                                
                                                <th>Total kWh</th>
                                                <th>Total Cost</th>
                                                <th>CO₂</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentMonthlyRows.length > 0 ? (
                                                currentMonthlyRows.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{(currentmonthlyreportPage - 1) * rowsmonthlyPerPage + index + 1}</td>
                                                        <td>{item.meterID}</td>
                                                        <td>{item.meterName}</td>
                                                        <td>{item.startKwh.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                                                        <td>{item.endKwh.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                                                        
                                                        <td>{item.totalKwh.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                                                        <td>{item.totalCost.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                                                        <td>{item.totalCo2.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>

                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" style={{ textAlign: "center" }}>
                                                        No Data Available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: "right" }}>TOTAL</td>
                                                <td>{monthsData.reduce((total, item) => total + item.totalKwh, 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                                                <td>{monthsData.reduce((total, item) => total + item.totalCost, 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                                                <td></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            )}
                            <div className="pagination-controls">
                                <button
                                    disabled={currentmonthlyreportPage === 1 || currentMonthlyRows.length === 0}
                                    onClick={() => handlemonthlyPageChange(currentmonthlyreportPage - 1)}
                                >
                                    Previous
                                </button>
                                <span>  {currentmonthlyreportPage}   of   {totalmonthlyPages}  </span>
                                <button
                                    disabled={currentmonthlyreportPage === totalmonthlyPages || currentMonthlyRows.length === 0}
                                    onClick={() => handlemonthlyPageChange(currentmonthlyreportPage + 1)}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EmsSubGroup;
